import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if error is from browser extensions (MetaMask, etc.)
    const errorMessage = error?.message || '';
    const isExtensionError = 
      errorMessage.includes('MetaMask') ||
      errorMessage.includes('ethereum') ||
      errorMessage.includes('chrome-extension') ||
      errorMessage.includes('moz-extension') ||
      errorMessage.includes('wallet');
    
    // Don't show error UI for extension errors
    if (isExtensionError) {
      console.warn('Browser extension error caught and suppressed:', errorMessage);
      return { hasError: false, error: null };
    }
    
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error for debugging but don't crash the app
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
          <div className="text-center max-w-md">
            <h2 className="text-xl font-bold text-foreground mb-4">حدث خطأ غير متوقع</h2>
            <p className="text-muted-foreground mb-6">نعتذر عن هذا الخطأ. يرجى تحديث الصفحة.</p>
            <button 
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
            >
              تحديث الصفحة
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
